export const storeProducts = [
  {
    id: 1,
    title: "G&L Tribute Legacy Electric Guitar Irish Ale",
    img: "img/gltribute.png",
    price: 499,
    company: "G&L",
    info:
      "The G&L Legacy is aptly named, blending contemporary refinements into Leo Fender's original G&L designs for  the S-500 and Comanche for an end result that delivers modern playability with vintage credibility.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Epiphone Les Paul SL Player Pack Pacific Blue",
    img: "img/epblue.png",
    price: 209,
    company: "Epiphone",
    info:
      "The Epiphone Les Paul SL™ Player Pack includes everything you need to start playing guitar right away at an incredible price.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title:
      "Fender Player Stratocaster Maple Fingerboard Electric Guitar Buttercream",
    img: "img/fenderbutter.png",
    price: 674,
    company: "Fender",
    info:
      "Over the decades, players have been continually inspired by the sound of a Strat. From the clarity of the high end, through the gut punch of the mids and the solid lows, it's a sound that's helped define what an electric guitar should be—versatile enough for any style and broad enough for any player to find an individual voice.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Gibson SG Standard 2018 Electric Guitar Heritage Cherry",
    img: "img/gibsred.png",
    price: 1299,
    company: "Gibson",
    info:
      "The 2018 SG Standard guitar captures the essence of the groundbreaking SG of 1961 with the sonic characteristics that made this model a legend. New and modern improvements include locking tuners and white fingerboard binding on a solid rosewood fingerboard.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title:
      "Squier Bullet Telecaster Limited Edition Electric Guitar Surf Green",
    img: "img/sqgreen.png",
    price: 179,
    company: "Squier",
    info:
      "The Bullet Tele is a simple, affordable and practical guitar designed for beginners and students. A perfect choice for a first guitar no matter who you are or what style of music you want to learn. Featuring the classic features that made the Tele one of the world’s favorite guitars, the Bullet Tele is a great introduction to the Fender family.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Alvarez Grateful Dead OM Acoustic Guitar Lightning",
    img: "img/gda.png",
    price: 499,
    company: "Alvarez",
    info:
      "Alvarez is incredibly proud to have worked with the Grateful Dead for many years and making signature models for Jerry Garcia and Bob Weir was a true honor. In the history of modern music, few bands have captured the hearts of so many people or created such a loyal following as the Dead.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Ibanez GRGR120EX Electric Guitar Black Night",
    img: "img/ibnblck.png",
    price: 199,
    company: "Ibanez",
    info:
      "Ibanez builds guitars for all levels of players—from beginners to the most demanding masters of the instrument. Regardless of price, Ibanez always strives to offer the absolute best sound, style, and playability in its class.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Ibanez GRGR120EX Electric Guitar Black Night",
    img: "img/gibpearl.png",
    price: 199,
    company: "Ibanez",
    info:
      "Ibanez builds guitars for all levels of players—from beginners to the most demanding masters of the instrument. Regardless of price, Ibanez always strives to offer the absolute best sound, style, and playability in its class.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 9,
    title: "Fender Acoustasonic Telecaster Acoustic-Electric Guitar Surf Green",
    img: "img/fenderacoustgreen.png",
    price: 1999,
    company: "Fender",
    info:
      "Handcrafted in Corona, California, the Fender American Acoustasonic Telecaster gives you a whole arsenal of convincing acoustic and electric tones in one great-feeling guitar. Thanks to its revolutionary Fender and Fishman-designed Acoustic Engine, you can choose from an assortment of 10 distinct guitar and tonewood combinations.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 10,
    title:
      "Epiphone Limited Edition Les Paul Traditional PRO-II Electric Guitar Ebony",
    img: "img/epiblack.png",
    price: 499,
    company: "Epiphone",
    info:
      "Epiphone introduces the new Les Paul Traditional PRO-II featuring the ultimate combo of Alnico Classic PRO and ProBucker humbuckers with coil-splitting for an incredible range of tones.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 11,
    title: "Taylor GS Mini Mahogany Acoustic Guitar Mahogany",
    img: "img/taylorac.png",
    price: 499,
    company: "Taylor",
    info:
      "There's something undeniably inviting about the Taylor GS Mini's scaled-down size, yet a single strum reveals the impressive voice of a full-size guitar. That mix of portability and musicality has proven to be a winning combination that fits into so many scenarios in life, from the couch to the campfire to the concert hall. It's not too big, it's not too precious, and it's not too expensive.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 12,
    title:
      "D'Angelico Premier Series SS Semi-Hollowbody Electric Guitar with Stairstep Tailpiece Transparent Wine",
    img: "img/dangelwine.png",
    price: 749,
    company: "D'Angelico",
    info:
      "D'Angelico's celebrated SS model has arrived in the Premier Series. A 15-inch-wide, single-cutaway archtop strapped with custom D'Angelico humbuckers, the Premier SS delivers a warm, full-bodied tone that is still crisp and clear. From clean jazz to soulful rock grit, its versatility is unmatched.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 13,
    title:
      "Squier Limited Edition Bullet Telecaster Electric Guitar  Red Sparkle",
    img: "img/redsparkle.png",
    price: 149,
    company: "Squier",
    info:
      "Equally at home in rock, jazz, blues or country, the Bullet Tele is a simple, affordable and practical guitar designed for beginners and students. A perfect choice for a first guitar no matter who you are or what style of music you want to learn.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 14,
    title:
      "Breedlove Discovery Concert CE 6-String Mahogany Acoustic-Electric Guitar Natural",
    img: "img/breedlovewood.png",
    price: 349,
    company: "Breedlove",
    info:
      "Breedlove’s distinctively crafted sound in the ultra-popular concert body shape, the Discovery Concert CE is ready for amplification and is outfitted for ease of playability with a soft cutaway. Whether you’re just learning, rekindling your passion for the instrument, or an experienced player in need of an affordable instrument that will inspire you, the Breedlove Discovery CE Concert is a great choice.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 15,
    title:
      "Fender American Elite Stratocaster HSS Maple Fingerboard Limited-Edition Electric Guitar Aqua Marine Metallic",
    img: "img/aquafender.png",
    price: 2099,
    company: "Fender",
    info:
      "When Fender created this limited-edition American Elite Stratocaster, their goal was to make a nearly irresistible instrument.  By taking the classic visual style that's kept the Strat at the forefront of electric guitars for over 60 years, and combining it with a modern feature set, they've succeeded beyond their wildest expectations.",
    inCart: false,
    count: 0,
    total: 0
  }
];
